module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/employee-basic-details/emp-basic-detail-grid/emp-basic-detail-grid.component.css
// module id = ./src/app/hrms/serviceregister/employee-basic-details/emp-basic-detail-grid/emp-basic-detail-grid.component.css
// module chunks = main